var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.target && _vm.effective ? _c('b-dropdown', {
    staticClass: "alarm-notifications-menu",
    attrs: {
      "right": "",
      "size": "sm",
      "variant": "primary",
      "menu-class": "menu"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('span', {
          staticClass: "fa-solid mr-1",
          class: _vm.effective.subscribed ? 'fa-bell' : 'fa-bell-slash'
        }), _c('span', {
          staticClass: "d-none d-md-inline"
        }, [_vm._v(_vm._s(_vm.$t("alarm_notifications.title")) + ":")]), _vm._v(" " + _vm._s(_vm.outcome) + " ")];
      },
      proxy: true
    }], null, false, 1089368242)
  }, [_c('li', {
    staticClass: "menu-body",
    attrs: {
      "role": "presentation"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-start mb-2"
  }, [_c('span', {
    staticClass: "fa-solid fa-fw target-icon mr-2",
    class: _vm.target.icon
  }), _c('div', {
    staticClass: "target-text"
  }, [_c('div', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(_vm.targetName))]), _vm.state === 'DEFAULT' ? _c('div', {
    staticClass: "text-aux small"
  }, [_vm._v(_vm._s(_vm.outcome))]) : _vm._e()])]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('AlarmNotificationToggle', {
    staticClass: "flex-grow-1",
    attrs: {
      "value": _vm.state,
      "disabled": _vm.isSaving,
      "block": ""
    },
    on: {
      "input": _vm.select
    }
  }), _vm.isSaving ? _c('b-spinner', {
    staticClass: "saving-spinner ml-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "text-right mt-2"
  }, [_c('router-link', {
    staticClass: "btn btn-link btn-sm link p-0",
    attrs: {
      "to": {
        name: 'UserAlarmNotifications',
        query: _vm.manageAllQuery
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("alarm_notifications.manage_all")) + " "), _c('span', {
    staticClass: "fa-solid fa-chevron-right ml-1"
  })])], 1)])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }